import { QuestionCircleOutlined } from '@ant-design/icons';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import TooltipComponent from 'components/atoms/TooltipComponent';
import React from 'react';

interface IInfoTooltip extends TooltipPropsWithTitle {
    title: string | undefined;
}

const InfoTooltip: React.FC<IInfoTooltip> = props => {
    const { title, ...rest } = props;
    if (title)
        return (
            <TooltipComponent {...rest} title={title}>
                <QuestionCircleOutlined
                    style={{
                        fontSize: 20,
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        color: '#006866',
                        marginLeft: 10,
                        marginRight: 10
                    }}
                />
            </TooltipComponent>
        );
    return <></>;
};

export default InfoTooltip;
